import { getString } from '@/utils/chatUtils/chatDefaultUtils';

type HelpDocBlockBodyProps = {
  item?: Record<string, unknown>;
};

export const HelpDocBlockBody = ({ item }: HelpDocBlockBodyProps) => {
  const title = getString(item?.title) || getString(item?.doc_slug);
  const content = getString(item?.content);

  if (!content) {
    return (
      <div className="chat-ui_missing">
        Help doc content was not available for this turn.
      </div>
    );
  }

  return (
    <div className="chat-ui_doc">
      {title ? <strong>{title}</strong> : null}
      <p>{content}</p>
    </div>
  );
};
